import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import CssBaseline from '@mui/material/CssBaseline';

import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox';
import Backdrop from "@mui/material/Backdrop";
import {withStyles} from "@mui/styles";
import {createTheme, ThemeProvider} from "@mui/material";


const MyBackdrop = withStyles(theme => ({
  root: {
    backgroundColor:'transparent'
  }
}))(Backdrop);

const TransDialog = ({title='', component, dialogHandler, callback}) => {
  // const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    // setOpen(false);
    dialogHandler[1](false)
    if(callback) {
      callback()
    }
  };

    
  return (
    <div>
      <Dialog
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0)' } }}
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        }}

        fullScreen
        open={dialogHandler[0]}
        back
        onClose={handleClose}
      >
        {component}
      </Dialog>
    </div>

  );
}

export default TransDialog